<template>
  <div
    id="salesData"
    v-loading.fullscreen.lock.body="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)"
  >
    <div
      style="
        overflow: hidden;
        height: 80px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
      "
    >
      <div style="margin-left: 20px; display: flex; align-items: center">
        <span style="font-size: 22px; padding-right: 10px">销售数据</span>
        <el-date-picker
          v-model="form.month"
          type="month"
          placeholder="选择月份"
          format="yyyy-MM"
          value-format="yyyy-MM"
          style="width: 120px"
          @change="changeYM"
        >
        </el-date-picker>
        <span style="padding-left: 6px">月份</span>
      </div>
      <div style="padding-right: 20px" v-if="role != 'staff'">
        <span style="padding-right: 6px">管理辖区</span>
        <el-select
          v-model="form.TerritoryList"
          placeholder="请选择"
          @change="changePrenTerritory"
        >
          <el-option
            v-for="(item, index) in TerritoryList"
            :key="index"
            :label="item.territory_name"
            :value="item.territory_id"
            :disabled="role == 'staff'"
          >
          </el-option>
        </el-select>
      </div>
    </div>
    <div style="width:100%">
    <TerritoryList
      :month="month"
      :territoryId="territory_id"
      :value="territoryArr"
      ref="myTerrList"
      @change="selectTerritory"
      style="padding-top: 8px"
    ></TerritoryList>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        height: 44px;
        align-items: center;
        background: #fff;
        padding: 15px 20px;
      "
    >
      <el-input
        v-model="searchValue"
        clearable
        size="small"
        prefix-icon="el-icon-search"
        placeholder="请输入搜索关键词"
      >
      </el-input>
      <el-button
        @click="onSearch"
        type="primary"
        color="#ff9901"
        style="margin-left: 15px"
        size="small"
        >搜索</el-button
      >
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        height: 44px;
        align-items: center;
      "
    >
      <el-radio-group
        fill="#FF9901"
        size="small"
        @change="getList"
        v-model="tabPosition"
      >
        <el-radio-button label="按产品">按产品</el-radio-button>
        <el-radio-button label="按客户">按客户</el-radio-button>
      </el-radio-group>
    </div>
    <div
      class="summary"
      style="height: 90px; background: #fff; padding: 0 20px"
    >
      <div class="summaryItem">
        <span
          style="
            color: #fff;
            padding: 4px 5px;
            background: #ff9901;
            font-size: 12px;
            border-radius: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
          >{{ territory_name || "暂无" }}</span
        >
        <span
          style="
            color: #4a90e2;
            font-size: 14px;
            padding-left: 5px;
            flex-shrink: 0;
          "
          >含税折后(万)&nbsp;<em>{{
            (info.discount_amount / 10000).toFixed(2)
          }}</em></span
        >
      </div>
      <div class="summaryItem summaryItem2">
        <span
          >指标:<em
            >{{ (info.target_amount / 10000).toFixed(2) }}&nbsp;<i
              class="rate"
              style="visibility: hidden"
              >%</i
            ></em
          ></span
        >
        <span
          >不含税折后(万):<em>{{
            (info.amount / 10000).toFixed(2)
          }}</em></span
        >
        <span
          >达成率:<em style="color: #ed3b3f"
            >{{ info.rate.toFixed(1) }}&nbsp;<i class="rate">%</i></em
          >
        </span>
      </div>
      <div class="summaryItem summaryItem2">
        <span
          >考核毛利率:<em style="color: #4a90e2"
            >{{ info.gross_rate.toFixed(1) }}&nbsp;<i class="rate">%</i></em
          ></span
        >
        <span
          >上月销售:<em style="color: #4a90e2">{{
            (info.last_amount / 10000).toFixed(2)
          }}</em></span
        >
        <span
          >增长率:<em style="color: #4a90e2"
            >{{ info.increase_rate.toFixed(1) }}&nbsp;<i class="rate">%</i></em
          ></span
        >
      </div>
    </div>
    <div v-if="tabPosition === '按产品'" ref="tableBox" style="">
      <el-table
        :data="list"
        ref="myTable"
        @row-click="salesDataDetail"
        style="width: 100%; background: #f5f7fa"
        @sort-change="sortChange"
        :header-cell-style="headerCellStyle"
        :cell-style="CellStyle"
      >
        <el-table-column prop="sku_name" label="产品"></el-table-column>
        <el-table-column
          prop="target_quantity"
          label="指标"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.target_quantity || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="actual_quantity"
          label="实际"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.actual_quantity || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="达成率"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span>{{ scope.row.rate || "-" }}</span>
              <img
                src="../../assets/images/next.png"
                style="float: right"
                height="11"
                alt="产品详情"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else ref="tableBox" style="">
      <el-table
        :data="list"
        ref="myTable"
        @row-click="salesDataDetail"
        style="width: 100%; background: #f5f7fa"
        :header-cell-style="headerCellStyle"
        @sort-change="sortChange"
        :cell-style="CellStyle"
      >
        <el-table-column prop="store_name" label="客户"></el-table-column>
        <el-table-column
          prop="target_amount"
          label="指标"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.target_amount || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="discount_amount"
          label="实际"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            <div>
              <span>{{ scope.row.discount_amount || "-" }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="rate"
          label="达成率"
          sortable="custom"
          width="120"
        >
          <template slot-scope="scope">
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
              "
            >
              <span>{{ scope.row.rate || "-" }}</span>
              <img
                src="../../assets/images/next.png"
                style="float: right"
                height="11"
                alt="产品详情"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import http from "../../APIService/http";
import moment from "moment";
import TerritoryList from "./components/endTerritoryList";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
  name: "salesData",
  data() {
    return {
      sArr : [],
      loading: false,
      form: {
        month: moment().format("YYYY-MM"),
        TerritoryList: "",
      },
      role: "",
      TerritoryList: [],
      info: {
        amount: 0,
        last_amount: 0,
        discount_amount: 0,
        target_amount: 0,
        rate: 0,
        gross_rate: 0,
        increase_rate: 0,
      },
      tabPosition: this.$store.state.salesData.tabPosition,
      territory_name: "",
      searchValue: "",
      list: [],
      territoryDatas:this.$store.getters.getTerritoryDatas,
    };
  },
  computed: {
    ...mapGetters({
      territoryArr:'getTerritoryArr'
    }),
    query() {
      return this.$store.getters.getDataQuery;
    },
    territory_id() {
      return this.form.TerritoryList;
    },
    month() {
      return this.form.month ;
    },
    search() {
      return this.$store.getters.getTerritorySearch;
    },
    territoryDatasLen() {
      return this.territoryDatas.length;
    },
  },
  components: {
    TerritoryList,
  },
  watch: {
    searchValue(val) {
      this.setDataKey({ search: val });
    },
    territoryDatasLen(val, old) {
      if (val > 1) {
        this.territory_name = "多个辖区";
      } else if (val === 0) {
        this.territory_name = "";
      } else {
        this.territory_name =
          this.territoryDatas[0].territory_name +
          `(${this.territoryDatas[0].territory_code})`;
      }
    },
  },
  async created() {
    debugger
    this.role = this.$store.getters.getUser.role;
    this.form.TerritoryList=this.$store.getters.getDataTerritoryId || ''
    this.form.month=this.$store.getters.getTerritoryMonth || moment().format("YYYY-MM")
    // this.getTerritoryArr = this.$store.getters.getTerritoryArr;
    // this.territoryDatas = this.$store.getters.getTerritoryDatas
    await this.getTerritoryList();

    this.setDataKey({
      query: {
        tenant_id: this.$store.getters.getUser.tenant_id,
        user_id: this.$store.getters.getUser.user_id,
      },
    });
    this.setDataKey({ territoryDatas: [] });
    this.territoryDatas=[]
    this.setDataKey({ territory_id: this.form.TerritoryList });
    if (this.territoryArr.length > 0) {
      await this.getList();
      // await this.SalesStatistics();
    }
  },
  mounted() {
    this.searchValue = this.search;
  },
  methods: {
    ...mapMutations(["setDataKey"]),
    async changeYM(val) {
      this.setDataKey({ territoryArr: [] });
      this.setDataKey({ territoryDatas: [] });
      this.setDataKey({ month: val });
      // await this.getList();
      // await this.SalesStatistics();
    },
    async changePrenTerritory(val) {
      this.setDataKey({ territoryArr: [] });
      this.setDataKey({ territoryDatas: [] });
      this.setDataKey({ territory_id: val });
      // await this.getList();
      // await this.SalesStatistics();
    },
    async onSearch() {
      await this.getList();
      await this.SalesStatistics();
    },
    //辖区
    async getTerritoryList() {
      let data = {
        user_id: this.$store.getters.getUser.user_id,
        tenant_id: this.$store.getters.getUser.tenant_id,
      };
      this.loading = true;
      let res = await http.post("/wapi/Territory/getTerritoryList", data);
      this.loading = false;
      if (res.success) {
        this.TerritoryList = res.data;
        for (var i = 0; i < this.TerritoryList.length; i++) {
          let a = this.TerritoryList[i];
          if (i == 0 && this.form.TerritoryList == "") {
            this.form.TerritoryList = a.territory_id;
          }
        }
      } else {
        Message.error(res.message);
      }
    },
    async selectTerritory(val) {
      let arr = val.map((item) => item.territory_id);
      let territoryDatas = [...val];
       this.territoryArr = arr
      this.sArr = arr
      this.territoryDatas = territoryDatas
      this.setDataKey({ territoryArr: arr });
      this.setDataKey({ territoryDatas: territoryDatas });

      await this.getList();
      await this.SalesStatistics();
    },
    async getList(v) {
      debugger
      v && this.setDataKey({ tabPosition: v });
      let query = this.query;
      let forms = {
        tenant_id: query.tenant_id,
        user_id: query.user_id,
        territoryIds: this.sArr.length > 0 ? [...this.sArr] : [...this.territoryArr],
        search: this.search,
        month: this.month || moment().format("YYYY-MM"),
      };
      let api = "";
      if (this.tabPosition == "按产品") {
        api = "b2b_sever/gkGetFeedback/productSalesList";
      } else {
        api = "b2b_sever/gkGetFeedback/clientSalesList";
      }
      this.loading = true;
      let res = await http.post(api, forms);
      this.loading = false;
      this.list = res.data;
      // .then((res) => {
      //   this.loading = false
      //   this.list = res.data
      // })
      // .catch((e) => {
      //   this.loading = false
      // })
    },

    async SalesStatistics() {
      let query = this.query;
      let forms = {
        tenant_id: query.tenant_id,
        user_id: query.user_id,
        search: this.search,
        territoryIds:this.sArr.length > 0 ? [...this.sArr] : [...this.territoryArr],
        month: this.month || moment().format("YYYY-MM"),
      };
      this.loading = true;
      let res = await http.post(
        "b2b_sever/gkGetFeedback/SalesStatistics",
        forms
      );
      this.loading = false;
      this.info = res.data;
      //     .then((res) => {
      //       this.loading = false
      //       this.info = res.data
      //     }).catch(e=>{
      //   this.loading = false
      // })
    },
    salesDataDetail(row, column, event) {
      if (this.tabPosition == "按产品") {
        this.setDataKey({ sku_id: row.sku_id });
        this.$router.push({ path: "/salesProductDetail" });
      } else {
        this.setDataKey({ store_id: row.store_id });
        this.$router.push({ path: "/salesClientDetail" });
      }
    },
    sortChange({ column, prop, order }) {
      if (order === "ascending") {
        this.list = this.list.sort((a, b) => {
          let v1 = new RegExp("[0-9]").test(a[prop])
            ? parseFloat(a[prop])
            : a[prop];
          let v2 = new RegExp("[0-9]").test(b[prop])
            ? parseFloat(b[prop])
            : b[prop];
          return v2 - v1;
        });
      } else {
        this.list = this.list.sort((a, b) => {
          let v1 = new RegExp("[0-9]").test(a[prop])
            ? parseFloat(a[prop])
            : a[prop];
          let v2 = new RegExp("[0-9]").test(b[prop])
            ? parseFloat(b[prop])
            : b[prop];
          return v1 - v2;
        });
      }
    },

    headerCellStyle() {
      return {
        "padding-top": "0",
        "padding-bottom": "0",
        "background-color": "#e0e0e0",
        color: "#5C575E",
      };
    },
    CellStyle({ row, column, rowIndex, columnIndex }) {
      if (column.label == "产品" || column.label == "客户") {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: "#87909A",
        };
      } else if (column.label == "达成率") {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: parseFloat(row.rate) >= 100 ? "#7ED321" : "#ED3B3F",
        };
      } else {
        return {
          "padding-top": "8px",
          "padding-bottom": "8px",
          color: "#4A4A4A",
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#salesData .summary span {
  font-weight: bold;
  color: #4d586d;
  display: inline-block;
}

#salesData .summary .summaryItem {
  font-size: 12px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#salesData .summary .summaryItem2 span {
  display: inline-flex;
  align-items: center;
  padding-right: 4px;
  justify-content: space-between;
  width: 34%;
}

#salesData .summary .summaryItem2 {
  margin-top: 12px;
}

#salesData .summary .summaryItem2 span:last-child {
  width: 32%;
}

#salesData .summary .summaryItem .rate {
  color: #fff;
  padding: 3px 4px;
  border-radius: 4px;
  background: #9b9b9b;
}

#salesData /deep/ .el-radio-button--small .el-radio-button__inner {
  font-size: 14px;
  color: #ff9901;
  border-color: #ff9901;
  padding: 6px 40px;
}

#salesData /deep/ .el-radio-button--small.is-active .el-radio-button__inner {
  color: #fff;
}

#salesData {
  overflow: auto;
  background: #fff;
}

.dateSelect {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
}

.dateSelect > img {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/salesdata/salesData.vue